module.exports = __webpack_public_path__ + "img/kvikkleire.d9eabfbb.jpg";